// extracted by mini-css-extract-plugin
export var animationContainer = "_i5-0";
export var asteriskIcon = "_i5-8";
export var conversationLeftSection = "_i5-4";
export var conversationListItem = "_i5-3";
export var conversationMiddleSection = "_i5-5";
export var conversationRightSection = "_i5-6";
export var detailsContent = "_i5-1";
export var listContainer = "_i5-7";
export var modalContent = "_i5-2";